// extracted by mini-css-extract-plugin
module.exports = {"planoBase":"ComponentePlanoAlimentar_planoBase__3_2zY","planoDados":"ComponentePlanoAlimentar_planoDados__3L6El"};